import React from 'react';
import { createComponent, PropTypes } from "../../../wayin-react";
import { sizes, textAlignments, assetServices, uploadAssetTypes } from "../../../enums";
import Modal from "../modal";
import Panel from "../../abstractions/panel";
import Layout from "../layout";
import Video from "../video";
import CKImage from "../image";
/**
 * modal preview showing a larger image/video preview
 */

var AssetPreview = createComponent({
  displayName: 'AssetPreview',
  propTypes: {
    previewModalVisible: PropTypes.bool.isRequired,
    hidePreviewModal: PropTypes.func.isRequired,
    headerText: PropTypes.string,
    bylineText: PropTypes.string,
    assetRefObj: PropTypes.object.isRequired,
    assetPath: PropTypes.string
  },
  defaultProps: {
    assetPath: '',
    headerText: '',
    bylineText: ''
  },
  render: function render(props) {
    var previewModalVisible = props.previewModalVisible,
        hidePreviewModal = props.hidePreviewModal,
        headerText = props.headerText,
        bylineText = props.bylineText,
        assetPath = props.assetPath,
        assetRefObj = props.assetRefObj,
        useVideoPreview = assetRefObj.service === assetServices.WEB_URL && assetRefObj.assetType === uploadAssetTypes.VIDEO_URL;
    return /*#__PURE__*/React.createElement(Modal, {
      showModal: previewModalVisible,
      onClose: hidePreviewModal,
      hasCloseIcon: true,
      isSolid: true,
      isInverted: false,
      style: {
        padding: '0'
      }
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Panel, {
      hasBorder: true,
      padding: {
        vertical: sizes.X2,
        horizontal: sizes.X2
      },
      header: headerText,
      byline: bylineText
    }), /*#__PURE__*/React.createElement(Layout, {
      columnStyles: {
        textAlign: textAlignments.CENTER
      },
      padding: {
        vertical: sizes.SMALL,
        horizontal: sizes.SMALL
      }
    }, !useVideoPreview ? /*#__PURE__*/React.createElement(CKImage, {
      src: assetPath
    }) : useVideoPreview ? /*#__PURE__*/React.createElement(Video, {
      src: assetRefObj.location
    }) : null)));
  }
});
export default AssetPreview;
//# sourceMappingURL=asset-preview.js.map